import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import UnitInput from "./unit";
import { sameDefaultValueCheck } from "../helpers";
import classnames from "classnames";
import ResetState from "./resetstate";
import { isEqual } from "lodash";

function BorderRadiusInput({ value, onChange, label, className, resetValue }) {
  const [checked, setChecked] = useState(sameDefaultValueCheck(value));

  const classes = classnames(
    "grigora-border-radius-input cursor-default",
    className,
  );

  return (
    <div className={classes}>
      <div className="m-2 flex items-center justify-between text-grigora-base">
        <div className="grigora-border-radius-input__label ">{label}</div>
        <ResetState
          active={!isEqual(value, resetValue)}
          onClick={(e) => {
            onChange(resetValue);
            e.preventDefault();
          }}
        />
        <button
          className={` p-1 border-none text-grigora-base border text-editor-text-main  `}
          onClick={(e) => setChecked(!checked)}
        >
          {checked ? (
            <FontAwesomeIcon icon={faLock} className="p-2" size="lg" />
          ) : (
            <FontAwesomeIcon icon={faLockOpen} className="p-2" size="lg" />
          )}
        </button>
      </div>
      <div className="grid grid-cols-6 gap-4">
        <div className="col-start-1  col-span-3">
          <UnitInput
            value={value?.topLeft}
            resetValue={""}
            isResetVisible={false}
            onChange={(e) => {
              if (e !== undefined && e !== null && checked) {
                onChange({
                  ...value,
                  topLeft: e,
                  topRight: e,
                  bottomLeft: e,
                  bottomRight: e,
                });
              } else {
                onChange({ ...value, topLeft: e });
              }
            }}
          />
        </div>
        <div className="col-end-7 col-span-3">
          <UnitInput
            value={value?.topRight}
            resetValue={""}
            isResetVisible={false}
            onChange={(e) => {
              if (e !== undefined && e !== null && checked) {
                onChange({
                  ...value,
                  topLeft: e,
                  topRight: e,
                  bottomLeft: e,
                  bottomRight: e,
                });
              } else {
                onChange({ ...value, topRight: e });
              }
            }}
          />
        </div>
        <div className="col-start-1 col-span-3">
          <UnitInput
            value={value?.bottomLeft}
            resetValue={""}
            isResetVisible={false}
            onChange={(e) => {
              if (e !== undefined && e !== null && checked) {
                onChange({
                  ...value,
                  topLeft: e,
                  topRight: e,
                  bottomLeft: e,
                  bottomRight: e,
                });
              } else {
                onChange({ ...value, bottomLeft: e });
              }
            }}
          />
        </div>
        <div className="col-end-7 col-span-3">
          <UnitInput
            value={value?.bottomRight}
            resetValue={""}
            isResetVisible={false}
            onChange={(e) => {
              if (e !== undefined && e !== null && checked) {
                onChange({
                  ...value,
                  topLeft: e,
                  topRight: e,
                  bottomLeft: e,
                  bottomRight: e,
                });
              } else {
                onChange({ ...value, bottomRight: e });
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default BorderRadiusInput;
